import React, { FC } from 'react';
import { MaterialSymbol } from '@/components/MaterialSymbol';
import DeleteButton from '@/components/DeleteButton';
import { useTranslation } from 'react-i18next';
import { noop } from '@/utils/functions';
import Container from '../../../../components/Container';
import { EditorSectionActionButtonProps } from '../../../lib/components/EditorSectionActionButton';

export type MediaBlockActionsProps = Pick<EditorSectionActionButtonProps, 'onDelete' | 'onDuplicate'>;

export const MediaBlockActions: FC<MediaBlockActionsProps> = ({ onDelete }) => {
  const { t: tCommon } = useTranslation('common');
  return (
    <Container right>
      <DeleteButton
        onConfirm={onDelete ?? noop}
        component='IconButton'
        tooltip={tCommon('remove')}
        deleteIcon={<MaterialSymbol name='do_not_disturb_on' />}
      />
    </Container>
  );
};

export default MediaBlockActions;
